
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-chatgpt-api-ui-for-developers",
      function () {
        return require("private-next-pages/free-chatgpt-api-ui-for-developers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-chatgpt-api-ui-for-developers"])
      });
    }
  